const isAdmin = () => ["Admin", "SuperAdmin"].includes(localStorage.getItem("role"));
const isTester = () => localStorage.getItem("role") === "Tester";
// Na een organisatie-switch staat "role" op de rol in die organisatie; de
// echte rol staat dan in "real_role" (zie Accountsettings.jsx).
const isSuperAdmin = () =>
  localStorage.getItem("role") === "SuperAdmin" ||
  (localStorage.getItem("impersonating") === "true" && localStorage.getItem("real_role") === "SuperAdmin");

export const FEATURE_ACCEPT_ENABLED = () => true;
export const FEATURE_FILTER_MODE_ENABLED = () => isAdmin() || isTester();
export const FEATURE_MISC_FILES_ENABLED = () => true;
// Eigen PDF-bon (src/CaseSummaryPdf) via een extra "PDF"-knop met het
// Cadmus-logo in de CaseDetailDrawer. Alleen SuperAdmin, om te testen; nooit
// in de Demo-rol (ook niet als SuperAdmin die een Demo-organisatie bekijkt).
export const FEATURE_CASE_SUMMARY_PDF = () =>
  isSuperAdmin() && localStorage.getItem("role") !== "Demo";


// --- Schakelaars (op false = oude gedrag) ---------------------------------

// Vorige/volgende case (IOS Form + scans) alvast in een cache laden vanuit
// de CaseDetailDrawer. false = geen prefetch, viewers downloaden zelf.
export const CASE_PREFETCH = true;

// IOS Form draait bij Next/Previous om als een kaart.
// false = geen flip, het IOS Form fadet mee met de kaart (zie hieronder).
export const PDF_FLIP = false;
// Zonder flip het IOS Form mee laten faden op het tempo van de kaart.
// false = het pdf verschijnt zodra het geladen is.
export const PDF_FADE_WITH_DRAWER = true;

// PDF-viewer: rubberband (zoals iOS) als je met ↑/↓ of slepen de boven- of
// onderkant raakt. Muiswiel/trackpad doen niet mee. false = gewoon stoppen
// bij de rand.
export const PDF_EDGE_BOUNCE = true;

// Scans-loader pas tonen als het laden ná het wegdraaien van de vorige
// scans nog langer dan 300ms duurt (niet al tijdens het wegdraaien). Bij
// gecachte scans zie je hem dan meestal niet. Op false = oude gedrag (loader
// vanaf het begin van het wegdraaien).
export const SCAN_LOADER_DELAY = true;

// Laad-animatie op het dot-grid. false = draaiende ring-spinner + "Loading...".
export const DOT_LOADER = false;
// DotLoader in één <canvas> tekenen i.p.v. ~250 losse div's met elk een
// eigen CSS-animatie (= ~250 GPU-lagen; Safari moet die elke frame boven het
// scans-canvas samenvoegen, wat het indraaien van de scans laat haperen).
// Tekent niks als hij onzichtbaar is. Alleen met DOT_LOADER. Op false = oude
// gedrag (div's + CSS).
export const DOT_LOADER_CANVAS = true;
// DotLoader als "scanner": een scankop met staartje loopt heen en weer over
// een tandboog op het dot-grid, met een pulsje op elk keerpunt. Alleen met
// DOT_LOADER_CANVAS. Op false = oude gedrag (ripple vanuit het midden).
export const DOT_LOADER_ARCH = true;

// Tools in de Scans-toolbar, achter Color/Mono (zie ScanTools.jsx). Elk los
// aan/uit; staan ze allemaal op false, dan is de toolbar zoals vroeger.
// Mesh: flat shading + draadmodel, om op de preparatiegrens de echte
// driehoeken te zien. Op false = oude gedrag (geen Mesh-knop).
export const SCAN_TOOL_MESH = false;
// Beet: afstandskaart tussen boven- en onderkaak, 0–1 mm (rood = contact/
// penetratie, geel/groen = 0,1–0,5 mm, blauw = ruimte). Op false = oude
// gedrag (geen Beet-knop).
export const SCAN_TOOL_BITE = false;
// Ondersnijdingen in rood t.o.v. een inzetrichting (= de kijkrichting bij
// aanzetten of "Richting = aanzicht"). Op false = oude gedrag (geen knop).
export const SCAN_TOOL_UNDERCUT = false;
// Doorsnede: snijvlak loodrecht op de kijkrichting, met schuif en een
// profiellijn per kaak. Op false = oude gedrag (geen Doorsnede-knop).
export const SCAN_TOOL_SECTION = false;
// Meten: klik twee punten op de scan = afstand in mm, met schaalbalk.
// Op false = oude gedrag (geen Meten-knop).
export const SCAN_TOOL_MEASURE = false;
// Preparatierapport: info-knop in de Scans-toolbar (alleen bij kroon- en
// brugwerk in de worktypes) met reductie, hoogte, ruimte, TOC en
// ondersnijdingen per pijler (zie prepReport.js). Op false = oude gedrag
// (geen info-knop).
export const SCAN_TOOL_PREP_REPORT = false;

// Tweakpanel voor belichting/materiaal van de scans, alleen voor SuperAdmin.
// false = geen panel (de waarden uit LOOK_DEFAULTS blijven gelden).
export const LOOK_PANEL = false;
// Het tweakpanel openen via "Settings" in de Scans-toolbar (na Glass) i.p.v.
// het losse "Look"-knopje rechtsboven. false = het losse knopje.
export const SETTINGS_IN_TOOLBAR = true;
// Settings als popover rechts (32px links van de case-card), onderkant net
// boven de Scans-toolbar, hoogte past zich aan de viewer aan, eigen
// scrollbar en vaste kop/voet. Alleen met SETTINGS_IN_TOOLBAR. Op false = oude gedrag (panel
// rechtsboven).
export const SETTINGS_POPOVER = true;
// FOV in Settings werkt direct (zoals exocad): camera schuift zo mee dat het
// model even groot in beeld blijft, scans worden niet opnieuw geladen.
// Orthografisch aan/uit laadt nog wel opnieuw. Op false = oude gedrag (FOV
// pas na "Camera toepassen", viewer laadt opnieuw).
export const LIVE_FOV = true;
// Glass-scanmode (naast Color/Mono) voor iedereen. false = geen Glass-knop.
export const GLASS_MODE = false;
// Glass-knop wel voor SuperAdmin, ook als GLASS_MODE uit staat.
// false = alleen GLASS_MODE telt.
export const GLASS_MODE_SUPERADMIN = false;
// Aaneengesloten geselecteerde rijen in de lijst delen één glow (als één
// geheel) i.p.v. elk een eigen glow. Checkboxes houden hun eigen glow.
// Op false = oude gedrag (elke rij een eigen glow).
export const ROW_GLOW_BLOCKS = true;
